/* ==================================================================
   MOKA HOME — ported from the homepage-V3.html IIFE, plus the live-data
   wiring added in the Shopify conversion:
     - reads the Liquid-rendered price/selling-plan map ([data-moka-prices])
       instead of the hardcoded PRICES object
     - /cart/add.js ATC that redirects straight to checkout (drawer skipped)
     - frequency <select> -> selling_plan input
     - Klaviyo email capture (client/subscriptions API)
     - cart drawer open/close, quantity, remove, Section Rendering refresh
       (drawer still powers the header cart icon; the buy-box CTA no longer opens it)
   Vanilla only. Loaded with defer.
   ================================================================== */
(function () {
  "use strict";

  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";

  /* ---------- in-page smooth scroll (trust bar -> first buy box) ----------
     The <a href="#choose-your-offer"> still works with no JS; this just upgrades
     the jump to a smooth scroll and respects the target's scroll-margin-top. */
  try {
    document.querySelectorAll("[data-moka-scroll]").forEach(function (el) {
      el.addEventListener("click", function (e) {
        var sel = el.getAttribute("data-moka-scroll");
        var target = sel && document.querySelector(sel);
        if (target) { e.preventDefault(); target.scrollIntoView({ behavior: "smooth", block: "start" }); }
      });
    });
  } catch (err) { /* non-fatal */ }

  /* ---------- prices: read the live Liquid map; fall back to locked constants ---------- */
  var DATA = { sellingPlans: [], atcReady: false };
  try {
    var dataEl = document.querySelector("[data-moka-prices]");
    if (dataEl) DATA = JSON.parse(dataEl.textContent);
  } catch (err) { /* keep fallback */ }

  var PRICES = DATA;
  if (!PRICES.solo || !PRICES.solo.onetime) {
    /* Static fallback = OFFER-LOCKED constants, so the page still renders if the
       data script is missing (e.g. no product selected in the editor). ATC stays off. */
    PRICES = {
      atcReady: false, sellingPlans: [],
      solo:   { variantId: 0, onetime: 30, sub: 24, anchor: 30, subSave: "SAVE £6", oneSave: null, subPerStick: "£24", onePerStick: "£30", shipOne: "£2.95 UK shipping. Free over £30.", shipSub: "£2.95 UK shipping. Free over £30." },
      duo:    { variantId: 0, onetime: 50, sub: 40, anchor: 60, subSave: "SAVE £20", oneSave: "SAVE £10", subPerStick: "£20", onePerStick: "£25", shipOne: "Free UK shipping.", shipSub: "Free UK shipping." },
      triple: { variantId: 0, onetime: 60, sub: 48, anchor: 90, subSave: "SAVE £42", oneSave: "SAVE £30", subPerStick: "£16", onePerStick: "£20", shipOne: "Free UK shipping.", shipSub: "Free UK shipping." },
      perstickSuffix: "each"
    };
  }

  /* Default plan is one-time (Josh, 13 Oct; was subscription from 27 Jul). state.freq = selected selling_plan id.
     freqTouched flips true the first time the shopper manually changes the frequency
     select — after that, switching tiers must never silently overwrite their choice
     (Josh, 29 Jul: re-picking a bundle shouldn't quietly change what they're charged on). */
  var state = { tier: "duo", plan: "onetime", freq: "", freqTouched: false };
  var firstFreq = document.querySelector('[data-el="sub-frequency"]');
  if (firstFreq) state.freq = firstFreq.value;

  /* Recommended delivery cadence per bundle size (Josh, 29 Jul). This assumes the live
     Appstle selling-plan group actually has plans at these exact week counts — if that
     app's plan cadence is ever edited (a plan renamed/removed), applyRecommendedFrequency
     below falls back to the closest available week count rather than failing silently
     with no recommendation at all. Still: if this map drifts from what's actually
     configured in Appstle, the "recommended" badge can land on the wrong option with no
     error surfaced anywhere — worth a periodic manual check if plans change upstream. */
  var TIER_RECOMMENDED_WEEKS = { solo: 4, duo: 8, triple: 12 };

  function fmt(n) { return "£" + (n % 1 === 0 ? n : n.toFixed(2)); }
  /* Null-safe text setter: a missing element must never throw and abort the IIFE,
     which would take down the gallery/carousels below it (Android bug, 27 Jul). */
  function setText(scope, sel, val) { var el = scope.querySelector(sel); if (el) el.textContent = val; }

  /* Re-labels the "(recommended)" option to match the current tier and, only if the
     shopper hasn't manually touched the select yet, pre-selects it. */
  function applyRecommendedFrequency(box) {
    var sel = box.querySelector('[data-el="sub-frequency"]');
    if (!sel) return;
    var wantWeeks = TIER_RECOMMENDED_WEEKS[state.tier];
    if (!wantWeeks) return;
    var options = Array.prototype.slice.call(sel.querySelectorAll("option[data-weeks]"));
    if (!options.length) return;

    var best = null, bestDiff = Infinity;
    options.forEach(function (opt) {
      var w = parseInt(opt.getAttribute("data-weeks"), 10);
      if (isNaN(w)) return;
      var diff = Math.abs(w - wantWeeks);
      if (diff < bestDiff) { bestDiff = diff; best = opt; }
    });
    if (!best) return;

    options.forEach(function (opt) {
      var base = opt.textContent.replace(/\s*\(recommended\)\s*$/, "");
      opt.textContent = (opt === best) ? base + " (recommended)" : base;
    });

    if (!state.freqTouched) {
      sel.value = best.value;
      state.freq = best.value;
    }
  }

  function render() {
    var p = PRICES[state.tier];
    var total = state.plan === "sub" ? p.sub : p.onetime;
    var label = state.plan === "sub"
      ? (PRICES.ctaSub || "Subscribe risk-free")
      : (PRICES.ctaOnetime || "Try it risk-free");
    document.querySelectorAll("[data-buybox]").forEach(function (box) {
      box.querySelectorAll("[data-tier]").forEach(function (card) {
        var on = card.getAttribute("data-tier") === state.tier;
        card.classList.toggle("is-selected", on);
        card.setAttribute("aria-checked", on ? "true" : "false");

        /* Tier price shows the per-stick price only (no bundle total in this picker,
           Josh 29 Jul) — the "per stick" label next to it is static markup, not JS-driven.
           Save still comes live from the variant price map; the show/hide toggle decides
           whether the row renders at all (may be absent). */
        var tp = PRICES[card.getAttribute("data-tier")];
        if (!tp) return;
        var priceEl = card.querySelector('[data-tf="price"]');
        var saveEl = card.querySelector('[data-tf="save"]');
        var isSub = state.plan === "sub";
        if (priceEl) priceEl.textContent = isSub ? tp.subPerStick : tp.onePerStick;
        if (saveEl) { var sv = isSub ? tp.subSave : tp.oneSave; if (sv) { saveEl.hidden = false; saveEl.textContent = sv; } else { saveEl.hidden = true; } }
      });
      box.querySelectorAll("[data-plan]").forEach(function (card) {
        var on = card.getAttribute("data-plan") === state.plan;
        card.classList.toggle("is-selected", on);
        card.setAttribute("aria-checked", on ? "true" : "false");
        var wrap = card.closest("[data-plan-wrap]");
        if (wrap) wrap.classList.toggle("is-selected", on);
      });
      setText(box, '[data-el="sub-strike"]', fmt(p.anchor));
      setText(box, '[data-el="sub-price"]', fmt(p.sub));
      setText(box, '[data-el="sub-save"]', p.subSave);
      setText(box, '[data-el="sub-perstick"]', p.subPerStick);
      /* "Under Xp a day": per-stick sub price over the shortest stick life (4 weeks = 28 days),
         rounded UP to the next 10p so the claim holds for heavy users. Solo 90p, Duo 80p, Trio 60p
         at today's prices; recomputes from the live price map if prices change. */
      var perDayEl = box.querySelector('[data-el="sub-perday"]');
      if (perDayEl) {
        var packSticks = { solo: 1, duo: 2, triple: 3 }[state.tier] || 1;
        var pence = Math.ceil(p.sub / packSticks * 100 / 28 / 10) * 10;
        perDayEl.textContent = pence < 100 ? pence + "p" : fmt(pence / 100);
      }
      setText(box, '[data-el="sub-ship"]', p.shipSub);
      /* one-time strike + save pill are intentionally absent from the markup now
         (Josh: one-time card shows the price only). Guard so their removal can't throw. */
      var strike = box.querySelector('[data-el="one-strike"]');
      if (strike) {
        /* Solo integrity: £29 never strikes through (anchor equals price) */
        if (p.anchor > p.onetime) { strike.hidden = false; strike.textContent = fmt(p.anchor); }
        else { strike.hidden = true; }
      }
      setText(box, '[data-el="one-price"]', fmt(p.onetime));
      var oneSave = box.querySelector('[data-el="one-save"]');
      if (oneSave) {
        if (p.oneSave) { oneSave.hidden = false; oneSave.textContent = p.oneSave; }
        else { oneSave.hidden = true; }
      }
      setText(box, '[data-el="one-ship"]', p.shipOne);
      /* Frequency picker only makes sense for a subscription; hide it on one-time */
      var freq = box.querySelector('[data-el="freq"]');
      if (freq) freq.hidden = (state.plan !== "sub");
      applyRecommendedFrequency(box);
      /* keep both boxes' frequency selects in sync */
      var sel = box.querySelector('[data-el="sub-frequency"]');
      if (sel && state.freq) sel.value = state.freq;
      setText(box, '[data-el="cta-label"]', label);
      var ctaStrike = box.querySelector('[data-el="cta-strike"]');
      if (ctaStrike) {
        if (p.anchor > total) { ctaStrike.hidden = false; ctaStrike.textContent = fmt(p.anchor); }
        else { ctaStrike.hidden = true; }
      }
      setText(box, '[data-el="cta-price"]', fmt(total));

      /* --- live wiring: keep the hidden cart inputs in step with state --- */
      var variantInput = box.querySelector('[data-el="variant-id"]');
      if (variantInput && p.variantId) variantInput.value = p.variantId;
      var planInput = box.querySelector('[data-el="selling-plan"]');
      if (planInput) {
        if (state.plan === "sub" && state.freq) { planInput.disabled = false; planInput.value = state.freq; }
        else { planInput.disabled = true; planInput.value = ""; }
      }
    });
  }

  document.querySelectorAll("[data-buybox]").forEach(function (box) {
    box.addEventListener("click", function (e) {
      var tier = e.target.closest("[data-tier]");
      var plan = e.target.closest("[data-plan]");
      if (tier) { state.tier = tier.getAttribute("data-tier"); render(); }
      else if (plan) { state.plan = plan.getAttribute("data-plan"); render(); }
    });
    var sel = box.querySelector('[data-el="sub-frequency"]');
    if (sel) sel.addEventListener("change", function () { state.freq = sel.value; state.freqTouched = true; render(); });
  });
  render();

  /* ---------- ATC: /cart/add.js, then go straight to checkout (drawer skipped) ----------
     Josh, 22 July: the buy-box CTA is the only ATC path on the page (every other CTA just
     scrolls here), so once someone submits this form they've already chosen a tier and a
     plan — a cart-drawer confirmation step is pure friction with nothing to sell in it.
     Works the same for subscriptions: /cart/add.js accepts selling_plan same as a one-time
     item, and Shopify's checkout renders a subscription line item straight from the cart,
     no special-casing needed. The header cart icon still opens the drawer (see below) for
     anyone who wants to review the cart without buying immediately. */
  document.querySelectorAll("[data-moka-atc]").forEach(function (form) {
    form.addEventListener("submit", function (e) {
      e.preventDefault();
      if (!PRICES.atcReady) return;
      var variantInput = form.querySelector('[data-el="variant-id"]');
      var planInput = form.querySelector('[data-el="selling-plan"]');
      var id = variantInput ? Number(variantInput.value) : 0;
      if (!id) return;
      var item = { id: id, quantity: 1 };
      if (state.plan === "sub" && planInput && !planInput.disabled && planInput.value) {
        item.selling_plan = Number(planInput.value);
      }
      var cta = form.querySelector('[data-el="cta"]');
      if (cta) { cta.setAttribute("aria-busy", "true"); cta.disabled = true; }
      fetch(ROOT + "cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", "Accept": "application/json" },
        body: JSON.stringify({ items: [item] })
      })
        .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
        .then(function (res) {
          if (!res.ok) {
            if (cta) {
              cta.removeAttribute("aria-busy");
              cta.disabled = false;
              cta.querySelector('[data-el="cta-label"]').textContent = "Out of stock";
            }
            var msg = (res.d && res.d.description) || "Sorry, that couldn't be added.";
            console.warn("MOKA ATC:", msg);
            return;
          }
          window.location.href = ROOT + "checkout";
        })
        .catch(function () { if (cta) { cta.removeAttribute("aria-busy"); cta.disabled = false; } });
    });
  });

  /* ---------- cart drawer (still used by the header cart icon) ---------- */
  var drawer = document.getElementById("moka-cart-drawer");
  var lastFocus = null;
  function openDrawer() {
    if (!drawer) return;
    lastFocus = document.activeElement;
    drawer.classList.add("is-open");
    drawer.setAttribute("aria-hidden", "false");
    document.documentElement.style.overflow = "hidden";
    var focusable = drawer.querySelector("[data-drawer-close], a, button");
    if (focusable) focusable.focus();
  }
  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove("is-open");
    drawer.setAttribute("aria-hidden", "true");
    document.documentElement.style.overflow = "";
    if (lastFocus) lastFocus.focus();
  }
  function updateSections(sections) {
    if (sections["moka-cart-drawer"]) {
      var doc = new DOMParser().parseFromString(sections["moka-cart-drawer"], "text/html");
      var fresh = doc.querySelector("[data-drawer-body]");
      var live = drawer ? drawer.querySelector("[data-drawer-body]") : null;
      if (fresh && live) live.innerHTML = fresh.innerHTML;
    }
    if (sections["cart-icon-bubble"]) {
      var doc2 = new DOMParser().parseFromString(sections["cart-icon-bubble"], "text/html");
      var fb = doc2.querySelector("#moka-cart-count");
      var lb = document.querySelector("#moka-cart-count");
      if (fb && lb) lb.replaceWith(fb);
    }
  }
  function refreshCart() {
    fetch(ROOT + "?sections=moka-cart-drawer,cart-icon-bubble")
      .then(function (r) { return r.json(); })
      .then(function (s) { updateSections(s); })
      .catch(function () {});
  }
  /* header cart icon opens the drawer (keeps href="/cart" as no-JS fallback) */
  var cartToggle = document.querySelector("[data-moka-cart-toggle]");
  if (cartToggle) cartToggle.addEventListener("click", function (e) { e.preventDefault(); openDrawer(); });
  if (drawer) {
    drawer.addEventListener("click", function (e) {
      if (e.target.closest("[data-drawer-close]") || e.target.hasAttribute("data-drawer-overlay")) { closeDrawer(); return; }
      var remove = e.target.closest("[data-cart-remove]");
      if (remove) { e.preventDefault(); changeLine(remove.getAttribute("data-line"), 0); return; }
      var minus = e.target.closest("[data-qty-minus]");
      var plus = e.target.closest("[data-qty-plus]");
      if (minus || plus) {
        var btn = minus || plus;
        var line = btn.getAttribute("data-line");
        var qty = Number(btn.getAttribute("data-qty")) + (plus ? 1 : -1);
        changeLine(line, Math.max(0, qty));
      }
    });
    document.addEventListener("keydown", function (e) { if (e.key === "Escape") closeDrawer(); });
  }
  function changeLine(line, quantity) {
    fetch(ROOT + "cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", "Accept": "application/json" },
      body: JSON.stringify({ line: Number(line), quantity: quantity, sections: "moka-cart-drawer,cart-icon-bubble", sections_url: window.location.pathname })
    })
      .then(function (r) { return r.json(); })
      .then(function (d) { if (d.sections) updateSections(d.sections); })
      .catch(function () {});
  }

  /* ---------- buy-box product gallery ---------- */
  document.querySelectorAll("[data-gallery]").forEach(function (gallery) {
    try {
      var mainImg = gallery.querySelector("[data-gallery-main]");
      var thumbs = Array.prototype.slice.call(gallery.querySelectorAll("[data-gallery-thumb]"));
      if (!mainImg || thumbs.length === 0) return;
      var current = 0;
      thumbs.forEach(function (t, i) { if (t.classList.contains("is-active")) current = i; });
      function show(i) {
        current = i;
        thumbs.forEach(function (t, idx) { t.classList.toggle("is-active", idx === i); });
        mainImg.src = thumbs[i].getAttribute("data-full");
        mainImg.alt = thumbs[i].getAttribute("data-alt") || "";
      }
      thumbs.forEach(function (t, i) { t.addEventListener("click", function () { show(i); }); });
      var prev = gallery.querySelector("[data-gallery-prev]");
      var next = gallery.querySelector("[data-gallery-next]");
      if (prev) prev.addEventListener("click", function () { show((current - 1 + thumbs.length) % thumbs.length); });
      if (next) next.addEventListener("click", function () { show((current + 1) % thumbs.length); });

      /* Swipe on the main image. Touch devices use touch events with an axis lock so a
         horizontal flick changes image while a vertical drag still scrolls the page;
         desktop falls back to a pointer drag. Paired with touch-action:pan-y (CSS) so
         Android Chrome doesn't steal the horizontal gesture before touchend fires. */
      var mainEl = gallery.querySelector(".moka-buy-gallery__main");
      if (mainEl) {
        function commit(dx) {
          if (dx <= -40) show((current + 1) % thumbs.length);
          else if (dx >= 40) show((current - 1 + thumbs.length) % thumbs.length);
        }
        var hasTouch = ("ontouchstart" in window) || (navigator.maxTouchPoints > 0);
        if (hasTouch) {
          var startX = null, startY = null, axis = "";
          mainEl.addEventListener("touchstart", function (e) {
            var t = e.touches[0]; startX = t.clientX; startY = t.clientY; axis = "";
          }, { passive: true });
          mainEl.addEventListener("touchmove", function (e) {
            if (startX === null) return;
            var t = e.touches[0];
            var dx = t.clientX - startX, dy = t.clientY - startY;
            if (!axis) {
              if (Math.abs(dx) < 6 && Math.abs(dy) < 6) return;
              axis = Math.abs(dy) > Math.abs(dx) * 1.4 ? "y" : "x";
            }
            if (axis === "x" && e.cancelable) e.preventDefault();
          }, { passive: false });
          mainEl.addEventListener("touchend", function (e) {
            if (startX !== null && axis === "x") {
              var t = (e.changedTouches && e.changedTouches[0]) || null;
              if (t) commit(t.clientX - startX);
            }
            startX = null; startY = null; axis = "";
          }, { passive: true });
        } else {
          var downX = null;
          mainEl.addEventListener("pointerdown", function (e) { downX = e.clientX; });
          mainEl.addEventListener("pointerup", function (e) { if (downX !== null) commit(e.clientX - downX); downX = null; });
        }
      }
    } catch (err) { /* one gallery must not take down the rest of the page */ }
  });

  /* ---------- reviews carousel: arrows + slow auto-scroll (native swipe stays live) ---------- */
  document.querySelectorAll("[data-judgeme-carousel]").forEach(function (car) {
   try {
    var track = car.querySelector("[data-rc-track]");
    if (!track) return;
    var prev = car.querySelector("[data-rc-prev]");
    var next = car.querySelector("[data-rc-next]");
    function step() {
      var card = track.querySelector(".moka-rc-card");
      return card ? card.getBoundingClientRect().width + 14 : track.clientWidth;
    }
    if (prev) prev.addEventListener("click", function () { track.scrollBy({ left: -step(), behavior: "smooth" }); });
    if (next) next.addEventListener("click", function () { track.scrollBy({ left: step(), behavior: "smooth" }); });

    /* Auto-scroll: continuous, slow, ping-pongs at the ends. Starts only once the
       carousel is on screen, pauses while the user interacts (so a swipe always wins),
       and stays off entirely for reduced-motion users. */
    var reduceMotion = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (!reduceMotion && "requestAnimationFrame" in window) {
      var SPEED = 32;            /* px per second — slow, readable drift */
      var dir = 1, visible = false, paused = false, running = false, resumeTimer = null, lastTs = 0;
      /* Track the position as a float ourselves: browsers round scrollLeft to whole
         pixels on write, so a raw "scrollLeft += 0.5" reads back as 0 and never moves.
         We accumulate in pos and only re-sync from the DOM after the user scrolls.
         maxScroll is measured up front (and on resize) rather than every frame — reading
         scrollWidth right after writing scrollLeft forces a reflow and makes the drift jerky. */
      var pos = 0, maxScroll = 0;
      function measure() { maxScroll = track.scrollWidth - track.clientWidth; }
      function frame(ts) {
        if (!running) return;
        if (!lastTs) lastTs = ts;
        var dt = (ts - lastTs) / 1000; lastTs = ts;
        if (dt > 0.1) dt = 0.1;   /* clamp after tab-away so it doesn't lurch */
        if (visible && !paused && maxScroll > 4) {
          pos += SPEED * dir * dt;
          if (pos >= maxScroll) { pos = maxScroll; dir = -1; }
          else if (pos <= 0) { pos = 0; dir = 1; }
          track.scrollLeft = pos;
        }
        requestAnimationFrame(frame);
      }
      function ensureRunning() { if (!running) { running = true; lastTs = 0; measure(); pos = track.scrollLeft; requestAnimationFrame(frame); } }
      function pause() { paused = true; if (resumeTimer) { clearTimeout(resumeTimer); resumeTimer = null; } }
      function resumeSoon() {
        if (resumeTimer) clearTimeout(resumeTimer);
        resumeTimer = setTimeout(function () { paused = false; lastTs = 0; measure(); pos = track.scrollLeft; }, 2500);
      }
      window.addEventListener("resize", function () { measure(); }, { passive: true });
      ["pointerdown", "touchstart", "wheel", "mouseenter"].forEach(function (ev) {
        track.addEventListener(ev, pause, { passive: true });
      });
      ["pointerup", "touchend", "mouseleave"].forEach(function (ev) {
        track.addEventListener(ev, resumeSoon, { passive: true });
      });
      /* Arrow clicks are a deliberate nudge — pause briefly, then resume. */
      [prev, next].forEach(function (b) { if (b) b.addEventListener("click", function () { pause(); resumeSoon(); }); });

      if ("IntersectionObserver" in window) {
        var autoIO = new IntersectionObserver(function (entries) {
          entries.forEach(function (en) { visible = en.isIntersecting; if (visible) ensureRunning(); });
        }, { threshold: 0.2 });
        autoIO.observe(car);
      } else {
        visible = true; ensureRunning();
      }
    }
   } catch (err) { /* one carousel must not take down the rest of the page */ }
  });

  /* ---------- Judge.me Review Carousel: reveal the static fallback if it never populates ----------
     The product-review widget only works on product pages; the store-wide Review Carousel
     (.jdgm-carousel) works anywhere but only if the widget is enabled in Judge.me. If Judge.me
     hasn't injected any review nodes within a few seconds, show the static cards so reviews are
     never blank on the homepage. */
  document.querySelectorAll("[data-jdgm-carousel-mount]").forEach(function (mount) {
    var carousel = mount.querySelector(".jdgm-carousel");
    var fallback = document.querySelector("[data-jdgm-fallback]");
    if (!fallback) return;
    function populated() {
      if (!carousel) return false;
      return carousel.querySelector(".jdgm-carousel-item, .jdgm-rev, .jdgm-carousel-item__body") != null ||
             carousel.textContent.trim().length > 0;
    }
    function showFallback() { fallback.hidden = false; mount.hidden = true; }
    function showCarousel() { fallback.hidden = true; mount.hidden = false; }
    var settled = false;
    if ("MutationObserver" in window && carousel) {
      var mo = new MutationObserver(function () { if (populated()) { settled = true; showCarousel(); mo.disconnect(); } });
      mo.observe(carousel, { childList: true, subtree: true });
      if (populated()) { settled = true; showCarousel(); mo.disconnect(); }
      setTimeout(function () { mo.disconnect(); if (!settled) showFallback(); }, 4000);
    } else {
      setTimeout(function () { if (!populated()) showFallback(); }, 4000);
    }
  });

  /* ---------- sticky mobile buy bar (verbatim port) ---------- */
  var stickyBar = document.querySelector("[data-sticky]");
  if (stickyBar) {
    var buyInView = false;
    /* Only show the sticky bar once the FIRST buy box has been scrolled past at least
       once — not while scrolling through the hero/marquee before reaching it. */
    var hasSeenBuy = false;
    var buySections = document.querySelectorAll(".moka-buy");
    var onScrollSticky = function () { stickyBar.hidden = (window.scrollY < 40) || buyInView || !hasSeenBuy; };
    if ("IntersectionObserver" in window && buySections.length) {
      var buyIO = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          en.target.mokaBuyInView = en.isIntersecting;
          if (en.isIntersecting) hasSeenBuy = true;
        });
        buyInView = Array.prototype.some.call(buySections, function (s) { return s.mokaBuyInView; });
        onScrollSticky();
      }, { rootMargin: "-72px 0px -76px 0px" });
      buySections.forEach(function (s) { buyIO.observe(s); });
    }
    window.addEventListener("scroll", onScrollSticky, { passive: true });
    onScrollSticky();
    /* Theme editor: the bar is hidden until scroll, so it's invisible when its section
       is clicked in the customizer. Reveal it on select so its settings are discoverable;
       restore normal scroll behaviour on deselect. (Still mobile-only CSS — use the
       editor's mobile preview.) */
    if (window.Shopify && window.Shopify.designMode) {
      document.addEventListener("shopify:section:select", function (e) {
        if (e.target.querySelector && e.target.querySelector("[data-sticky]")) stickyBar.hidden = false;
      });
      document.addEventListener("shopify:section:deselect", function (e) {
        if (e.target.querySelector && e.target.querySelector("[data-sticky]")) onScrollSticky();
      });
    }
  }

  /* ---------- Meta ViewContent: on this one-pager, the buy box IS the product page ----------
     Shopify only emits its native product_viewed event on a /products/ URL, and every Meta ad
     lands on "/", so the pixel's ViewContent never fires — 19 events against 44 AddToCarts in
     the 30 days to 8 Aug 2026, which is backwards and leaves the mid-funnel signal empty.
     This publishes a Shopify custom event when the first buy box reaches the middle of the
     viewport; the "Meta ViewContent (buy box)" custom pixel (Settings > Customer events)
     subscribes to it and calls fbq ViewContent. Nothing here touches Meta directly — going
     through Customer events keeps the call inside Shopify's consent handling.

     Fires at most once per page load: both buy boxes (buy_top and buy_mid) share the flag, so
     scrolling past the second one can't double-count. */
  (function () {
    var buyBoxes = document.querySelectorAll(".moka-buy");
    if (!buyBoxes.length || !("IntersectionObserver" in window)) return;
    if (!window.Shopify || !window.Shopify.analytics || !window.Shopify.analytics.publish) return;
    /* The customizer scrolls sections in and out of view constantly, so Josh's own editing
       session would otherwise emit a stream of junk ViewContents. */
    if (window.Shopify.designMode) return;
    /* Product pages (product.moka-pdp) already get ViewContent from Shopify's native
       product_viewed; publishing this too would double-count it. */
    if (/\/products\//.test(window.location.pathname)) return;
    /* No product selected in the editor => PRICES is the static fallback, which carries no
       real ids. Firing content_ids: ["0"] would poison the catalog match, so stay silent. */
    if (!PRICES.productId) return;

    var sentVC = false;
    var vcIO = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (sentVC || !en.isIntersecting) return;
        sentVC = true;
        vcIO.disconnect();
        /* Read the shared `state` object rather than the DOM: render() drives the visible
           prices off it, so the reported value can never disagree with what the visitor is
           looking at. Default selection is now duo + one-time (13 Oct); originally duo + sub — reading
           priced.onetime here instead reported £50 against a page showing £40 (caught in the
           8 Aug browser capture). */
        var priced = PRICES[state.tier] || PRICES.duo || {};
        try {
          window.Shopify.analytics.publish("moka_buybox_viewed", {
            productId: PRICES.productId,
            productTitle: PRICES.productTitle || "",
            variantId: priced.variantId || 0,
            tier: state.tier,
            plan: state.plan,
            value: (state.plan === "sub" ? priced.sub : priced.onetime) || 0,
            currency: "GBP"
          });
        } catch (err) { /* analytics must never break the buy box */ }
      });
    }, { threshold: 0, rootMargin: "-25% 0px -25% 0px" });
    /* rootMargin, not a threshold ratio: the buy box is taller than a phone viewport, so any
       threshold above 0 would never resolve on mobile. This fires when it enters the middle
       half of the screen, which is a real "scrolled to the offer", not a 1px sliver. */
    Array.prototype.forEach.call(buyBoxes, function (b) { vcIO.observe(b); });
  })();

  /* ---------- capture popup: once, only after the buy box scrolls out of view above (verbatim port) ---------- */
  var popup = document.querySelector("[data-popup]");
  var teaser = document.querySelector("[data-teaser]");
  function openPopup() { if (popup) popup.hidden = false; }
  function closePopup() {
    if (popup) popup.hidden = true;
    if (teaser) teaser.hidden = false;
    try { sessionStorage.setItem("moka-popup-done", "1"); } catch (err) {}
  }
  var popupDone = (function () { try { return sessionStorage.getItem("moka-popup-done"); } catch (err) { return true; } })();
  if (popup && !popupDone) {
    /* Trigger off the whole first buy SECTION (.moka-buy), not the #choose-your-offer
       anchor — that id now lives on the small .moka-buy-head, which would fire the popup
       far too early. Observing the section restores "fire once, after the offer scrolls
       fully out of view above" (Law 36). */
    var offerSection = document.querySelector(".moka-buy");
    if (offerSection && "IntersectionObserver" in window) {
      var fired = false;
      var seenOffer = false;
      var offerIO = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (fired) return;
          if (en.isIntersecting) {
            seenOffer = true;
          } else if (seenOffer && en.rootBounds && en.boundingClientRect.bottom <= en.rootBounds.top) {
            fired = true;
            openPopup();
            offerIO.disconnect();
          }
        });
      }, { threshold: 0 });
      offerIO.observe(offerSection);
    }
  } else if (popup && teaser) {
    /* Popup already shown/dismissed this session — keep the teaser tab visible so the
       email-capture entry point is never lost on a refresh within the same session. */
    teaser.hidden = false;
  }
  /* Theme editor: nothing scrolls, so the popup/teaser are invisible and undiscoverable.
     Reveal the teaser whenever the Sticky bar & popup section is selected. */
  if (window.Shopify && window.Shopify.designMode && teaser) {
    document.addEventListener("shopify:section:select", function (e) {
      if (e.target.querySelector && e.target.querySelector("[data-teaser]")) teaser.hidden = false;
    });
  }
  if (popup) {
    popup.addEventListener("click", function (e) {
      if (e.target === popup || e.target.closest("[data-popup-close]")) closePopup();
    });
  }
  if (teaser) {
    teaser.addEventListener("click", function () {
      teaser.hidden = true;
      try { sessionStorage.removeItem("moka-popup-done"); } catch (err) {}
      openPopup();
    });
  }

  /* ---------- capture forms: Klaviyo client/subscriptions ---------- */
  document.querySelectorAll("[data-capture]").forEach(function (form) {
    form.addEventListener("submit", function (e) {
      e.preventDefault();
      var note = form.parentElement.querySelector("[data-capture-note]");
      var errNote = form.parentElement.querySelector("[data-capture-error]");
      var listId = form.getAttribute("data-klaviyo-list");
      var companyId = form.getAttribute("data-klaviyo-company");
      var email = (form.querySelector('input[type="email"]') || {}).value;
      var consent = form.querySelector('input[name="email-consent"]');
      if (errNote) errNote.style.display = "none";
      if (!email) return;
      if (!listId || !companyId) {
        /* misconfigured: fail safe, do not pretend it worked */
        if (errNote) errNote.style.display = "block";
        return;
      }
      var submitBtn = form.querySelector('button[type="submit"]');
      if (submitBtn) submitBtn.disabled = true;
      var payload = {
        data: {
          type: "subscription",
          attributes: {
            custom_source: "MOKA homepage popup",
            profile: { data: { type: "profile", attributes: { email: email,
              properties: { email_consent_checkbox: consent ? consent.checked : false } } } }
          },
          relationships: { list: { data: { type: "list", id: listId } } }
        }
      };
      fetch("https://a.klaviyo.com/client/subscriptions/?company_id=" + encodeURIComponent(companyId), {
        method: "POST",
        headers: { "Content-Type": "application/json", "revision": "2024-10-15" },
        body: JSON.stringify(payload)
      })
        .then(function (r) {
          if (submitBtn) submitBtn.disabled = false;
          if (r.ok || r.status === 202) {
            if (note) note.style.display = "block";
            form.style.display = "none";
            try { sessionStorage.setItem("moka-popup-done", "1"); } catch (err) {}
          } else {
            if (errNote) errNote.style.display = "block";
          }
        })
        .catch(function () { if (submitBtn) submitBtn.disabled = false; if (errNote) errNote.style.display = "block"; });
    });
  });

  /* ---------- ingredients carousel ---------- */
  document.querySelectorAll("[data-carousel]").forEach(function (car) {
   try {
    var viewport = car.querySelector(".moka-car-viewport");
    var track = car.querySelector("[data-car-track]");
    if (!viewport || !track) return;
    var cards = Array.prototype.slice.call(track.children);
    if (cards.length === 0) return;
    var dotsWrap = car.querySelector("[data-car-dots]");
    var index = 0;
    cards.forEach(function (_, i) {
      var dot = document.createElement("button");
      dot.type = "button";
      dot.setAttribute("aria-label", "Go to ingredient " + (i + 1));
      dot.addEventListener("click", function () { index = i; update(); });
      dotsWrap.appendChild(dot);
    });
    var dots = Array.prototype.slice.call(dotsWrap.children);
    function update() {
      var cw = cards[0].offsetWidth;
      var step = Math.round(cw * 0.58);
      var maxH = 0;
      cards.forEach(function (c, i) {
        var d = i - index;
        var ad = Math.abs(d);
        c.style.transform = "translateX(calc(-50% + " + (d * step) + "px)) scale(" + (i === index ? 1 : 0.86) + ")";
        c.style.zIndex = String(100 - ad * 10);
        c.style.opacity = i === index ? "1" : (ad === 1 ? "0.55" : "0");
        c.classList.toggle("is-active", i === index);
        if (c.offsetHeight > maxH) maxH = c.offsetHeight;
      });
      track.style.height = maxH + "px";
      dots.forEach(function (dt, i) { dt.classList.toggle("is-active", i === index); });
    }
    car.querySelector("[data-car-prev]").addEventListener("click", function () {
      index = (index - 1 + cards.length) % cards.length; update();
    });
    car.querySelector("[data-car-next]").addEventListener("click", function () {
      index = (index + 1) % cards.length; update();
    });
    /* Swipe: advance as the finger moves (multiple cards per gesture). THRESHOLD is the
       horizontal travel that advances one card. The gesture is claimed as horizontal
       generously — anything not clearly steeper-than-vertical counts — so sloppy diagonal
       swipes still move the deck instead of falling through to page scroll. */
    var THRESHOLD = 40;
    var startX = null, startY = null, axis = "";
    function stepFromDx(dx, e) {
      if (dx <= -THRESHOLD && index < cards.length - 1) { index++; startX = e.clientX; startY = e.clientY; update(); }
      else if (dx >= THRESHOLD && index > 0) { index--; startX = e.clientX; startY = e.clientY; update(); }
    }
    function endSwipe() { startX = null; startY = null; axis = ""; viewport.classList.remove("is-dragging"); }

    var hasTouch = ("ontouchstart" in window) || (navigator.maxTouchPoints > 0);
    if (hasTouch) {
      /* Touch path: decide axis on the first real move and preventDefault once we own a
         horizontal swipe, which stops the browser from stealing it as a vertical scroll.
         touchmove must be non-passive for preventDefault to take effect. */
      viewport.addEventListener("touchstart", function (e) {
        var t = e.touches[0]; startX = t.clientX; startY = t.clientY; axis = "";
      }, { passive: true });
      viewport.addEventListener("touchmove", function (e) {
        if (startX === null) return;
        var t = e.touches[0];
        var dx = t.clientX - startX, dy = t.clientY - startY;
        var adx = Math.abs(dx), ady = Math.abs(dy);
        if (!axis) {
          if (adx < 6 && ady < 6) return;            /* wait for a real move */
          axis = ady > adx * 1.4 ? "y" : "x";         /* only steep drags scroll the page */
          if (axis === "x") viewport.classList.add("is-dragging");
        }
        if (axis === "y") return;                     /* vertical -> let the page scroll */
        if (e.cancelable) e.preventDefault();         /* own the horizontal swipe */
        stepFromDx(dx, t);
      }, { passive: false });
      viewport.addEventListener("touchend", endSwipe, { passive: true });
      viewport.addEventListener("touchcancel", endSwipe, { passive: true });
    } else {
      /* Mouse path: plain pointer drag on desktop (arrows/dots also available). */
      viewport.addEventListener("pointerdown", function (e) {
        startX = e.clientX; startY = e.clientY; axis = "x"; viewport.classList.add("is-dragging");
      });
      viewport.addEventListener("pointermove", function (e) {
        if (startX === null) return;
        stepFromDx(e.clientX - startX, e);
      });
      viewport.addEventListener("pointerup", endSwipe);
      viewport.addEventListener("pointerleave", endSwipe);
    }
    window.addEventListener("resize", update);
    update();
    car.querySelectorAll("[data-car-more]").forEach(function (btn) {
      btn.addEventListener("click", function () {
        var detail = btn.parentElement.querySelector(".moka-ing-more");
        var open = detail.hidden;
        detail.hidden = !open;
        btn.setAttribute("aria-expanded", open ? "true" : "false");
        btn.textContent = open ? "Show less" : "Show more";
        update();
      });
    });

    /* Auto-advance: while the deck is on screen, snap to the next card once a second —
       the same motion as tapping the next arrow, looping back at the end. Any manual
       drive (swipe, arrow, dot, Show more) holds it off for a few seconds so it never
       fights the user; it stays paused whenever the deck is scrolled out of view. */
    var reduceMotionCar = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (!reduceMotionCar && cards.length > 1) {
      var FIRST_DELAY = 2000, STEP_DELAY = 1000;
      var carVisible = false, holdUntil = 0, started = false, timer = null;
      function bumpPause() { holdUntil = Date.now() + 4000; }
      ["pointerdown", "touchstart"].forEach(function (ev) { car.addEventListener(ev, bumpPause, { passive: true }); });
      car.addEventListener("click", bumpPause);   /* arrows, dots, Show more */
      function scheduleNext(ms) { if (timer) clearTimeout(timer); timer = setTimeout(runTick, ms); }
      function runTick() {
        timer = null;
        if (!carVisible) { started = false; return; }   /* stop; re-arms on re-entry */
        var now = Date.now();
        if (now < holdUntil) { scheduleNext(holdUntil - now); return; }
        index = (index + 1) % cards.length;
        update();
        scheduleNext(STEP_DELAY);
      }
      function arm() { if (started) return; started = true; scheduleNext(FIRST_DELAY); }
      if ("IntersectionObserver" in window) {
        var carIO = new IntersectionObserver(function (entries) {
          entries.forEach(function (en) { carVisible = en.isIntersecting; if (carVisible) arm(); });
        }, { threshold: 0.3 });
        carIO.observe(car);
      } else {
        carVisible = true; arm();
      }
    }
   } catch (err) { /* one carousel must not take down the rest of the page */ }
  });

  /* ---------- before/after carousel (one slide at a time) ---------- */
  document.querySelectorAll("[data-ba]").forEach(function (car) {
    try {
      var track = car.querySelector("[data-ba-track]");
      if (!track) return;
      var slides = Array.prototype.slice.call(track.children);
      if (slides.length === 0) return;
      var dotsWrap = car.querySelector("[data-ba-dots]");
      var i = 0, dots = [];
      function go(n) {
        i = (n + slides.length) % slides.length;
        track.style.transform = "translateX(-" + (i * 100) + "%)";
        dots.forEach(function (d, idx) { d.classList.toggle("is-active", idx === i); });
      }
      if (dotsWrap) slides.forEach(function (_, n) {
        var d = document.createElement("button");
        d.type = "button"; d.setAttribute("aria-label", "Go to slide " + (n + 1));
        d.addEventListener("click", function () { go(n); });
        dotsWrap.appendChild(d); dots.push(d);
      });
      var prev = car.querySelector("[data-ba-prev]");
      var next = car.querySelector("[data-ba-next]");
      if (prev) prev.addEventListener("click", function () { go(i - 1); });
      if (next) next.addEventListener("click", function () { go(i + 1); });
      var vp = car.querySelector(".moka-ba-viewport");
      if (vp) {
        function commit(dx) { if (dx <= -40) go(i + 1); else if (dx >= 40) go(i - 1); }
        var hasTouch = ("ontouchstart" in window) || (navigator.maxTouchPoints > 0);
        if (hasTouch) {
          var sx = null, sy = null, ax = "";
          vp.addEventListener("touchstart", function (e) { var t = e.touches[0]; sx = t.clientX; sy = t.clientY; ax = ""; }, { passive: true });
          vp.addEventListener("touchmove", function (e) {
            if (sx === null) return;
            var t = e.touches[0], dx = t.clientX - sx, dy = t.clientY - sy;
            if (!ax) { if (Math.abs(dx) < 6 && Math.abs(dy) < 6) return; ax = Math.abs(dy) > Math.abs(dx) * 1.4 ? "y" : "x"; }
            if (ax === "x" && e.cancelable) e.preventDefault();
          }, { passive: false });
          vp.addEventListener("touchend", function (e) {
            if (sx !== null && ax === "x") { var t = (e.changedTouches && e.changedTouches[0]) || null; if (t) commit(t.clientX - sx); }
            sx = null; sy = null; ax = "";
          }, { passive: true });
        } else {
          var dX = null;
          vp.addEventListener("pointerdown", function (e) { dX = e.clientX; });
          vp.addEventListener("pointerup", function (e) { if (dX !== null) commit(e.clientX - dX); dX = null; });
        }
      }
      go(0);
    } catch (err) { /* one carousel must not take down the rest of the page */ }
  });

  /* ---------- scroll reveal (verbatim port) ---------- */
  if ("IntersectionObserver" in window) {
    var revealTargets = Array.prototype.slice.call(document.querySelectorAll(
      ".moka-problem, .moka-vp, .moka-ingredients, .moka-founder, .moka-usthem, " +
      ".moka-made, .moka-thirty, .moka-results, .moka-reviews-carousel, .moka-guarantee, .moka-faq, .moka-final"
    ));
    revealTargets.forEach(function (el) { el.classList.add("moka-reveal"); });
    var revealIO = new IntersectionObserver(function (entries, obs) {
      entries.forEach(function (en) {
        if (en.isIntersecting) {
          en.target.classList.add("is-visible");
          obs.unobserve(en.target);
        }
      });
    }, { threshold: 0.12, rootMargin: "0px 0px -60px 0px" });
    revealTargets.forEach(function (el) { revealIO.observe(el); });
  }

  /* ---------- sync our rating lines to Judge.me's own combined total ----------
     shop.metafields.judgeme.all_reviews_count exists (verified via Admin API) but
     isn't resolving in Liquid, so our server-rendered rating lines under-count
     (product-only, e.g. 11) vs Judge.me's own Cards Carousel header (product +
     store, e.g. 13). The carousel's count/score ARE already server-rendered into
     the page (view-source has them, no fetch needed) — just read them from its
     DOM and copy into our own rating spans so every number on the page agrees. */
  function syncRatingsFromJudgeme() {
    var countEl = document.querySelector(".jdgm-reviews-count");
    var starsEl = document.querySelector(".jdgm-stars[aria-label]");
    if (!countEl || !starsEl) return false;
    var count = countEl.textContent.trim();
    var match = starsEl.getAttribute("aria-label").match(/([\d.]+)/);
    if (!count || !match) return false;
    var score = parseFloat(match[1]).toFixed(1);
    var text = score + " from " + count + " reviews";
    document.querySelectorAll('[data-el="jm-rating-text"]').forEach(function (el) {
      el.textContent = text;
    });
    return true;
  }
  if (!syncRatingsFromJudgeme()) {
    var jmTries = 0;
    var jmTimer = setInterval(function () {
      jmTries++;
      if (syncRatingsFromJudgeme() || jmTries > 20) clearInterval(jmTimer);
    }, 250);
  }

  /* ---------- weekend offer: countdown bar (moka-announce) + panel (moka-offer-panel, moved under the top buy box heading) ----------
     Display only: the discount is auto-applied by Shopify, so this never touches prices,
     the buy box or checkout. Config is the [data-moka-offer] JSON moka-announce renders
     only while the offer is live. Switches everything off at the end time, or if the real
     claimed count reaches the cap. Digits roll (old fades up, new rises in) instead of a
     hard flip; reduced-motion visitors get a plain swap. */
  (function () {
    var cfgEl = document.querySelector("[data-moka-offer]");
    if (!cfgEl) return;
    var OFFER;
    try { OFFER = JSON.parse(cfgEl.textContent); } catch (err) { return; }
    var END = Date.parse(OFFER.end);
    if (isNaN(END)) return;

    var bars = document.querySelectorAll("[data-moka-offer-bar]");
    var panels = document.querySelectorAll("[data-moka-offer-panel]");
    var reduce = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    var EASE = "cubic-bezier(0.22, 0.61, 0.36, 1)", DUR = 600;
    function pad(n) { return (n < 10 ? "0" : "") + n; }
    function live() { return Date.now() < END && OFFER.claimed < OFFER.cap; }

    function roll(cell, ch) {
      var old = cell.lastElementChild;
      if (old && old.textContent === ch) return;
      var next = document.createElement("span");
      next.textContent = ch;
      cell.appendChild(next);
      if (!old) return;
      if (reduce || !next.animate) { old.remove(); return; }
      old.animate([{ transform: "translateY(0)", opacity: 1 }, { transform: "translateY(-55%)", opacity: 0 }], { duration: DUR, easing: EASE, fill: "forwards" })
        .onfinish = function () { old.remove(); };
      next.animate([{ transform: "translateY(55%)", opacity: 0 }, { transform: "translateY(0)", opacity: 1 }], { duration: DUR, easing: EASE });
    }
    function rollNumber(host, n) {
      var str = String(n);
      while (host.children.length < str.length) { var c = document.createElement("span"); c.className = "moka-roll"; host.appendChild(c); }
      while (host.children.length > str.length) host.lastElementChild.remove();
      Array.prototype.forEach.call(host.children, function (c, i) { roll(c, str[i]); });
    }

    /* Build each clock once: d/h/m/s pairs, each digit its own rolling cell. */
    var NAMES = { d: "days", h: "hrs", m: "min", s: "sec" };
    var clocks = Array.prototype.map.call(document.querySelectorAll("[data-moka-clock]"), function (el) {
      var units = el.hasAttribute("data-units"), seps = el.hasAttribute("data-seps");
      el.innerHTML = ["d", "h", "m", "s"].map(function (k, i) {
        return (i && seps ? '<span class="moka-clock-sep">:</span>' : "") +
          '<span class="moka-clock-grp"><span class="moka-clock-digs"><span class="moka-clock-d"></span><span class="moka-clock-d"></span></span>' +
          (units ? '<span class="moka-clock-u">' + NAMES[k] + "</span>" : "") + "</span>";
      }).join("");
      return el.querySelectorAll(".moka-clock-d");
    });

    function syncHeaderOffset() {
      var wrap = document.querySelector(".moka-announce-wrap");
      if (wrap) document.documentElement.style.setProperty("--moka-announce-h", wrap.offsetHeight + "px");
    }
    var timer = null;
    function switchOff() {
      if (timer) clearInterval(timer);
      Array.prototype.forEach.call(bars, function (b) { b.hidden = true; });
      Array.prototype.forEach.call(panels, function (p) { p.hidden = true; });
      syncHeaderOffset();
    }
    function tick() {
      if (!live()) { switchOff(); return; }
      var s = Math.floor((END - Date.now()) / 1000);
      var str = pad(Math.floor(s / 86400)) + pad(Math.floor(s % 86400 / 3600)) + pad(Math.floor(s % 3600 / 60)) + pad(s % 60);
      clocks.forEach(function (cells) { Array.prototype.forEach.call(cells, function (c, i) { roll(c, str[i]); }); });
    }

    if (!live()) { switchOff(); return; }
    var shown = Math.min(OFFER.cap, Math.max(OFFER.floor, OFFER.claimed));
    /* Panel sits under the top buy box's heading: insert it just before the first buy-box form
       (the heading precedes the form inside .moka-buy-copy). Only the panel marked
       data-moka-offer-move (moka-offer-panel) is moved; other panels, e.g. the sale buy box's
       built-in timer, are filled in place. The buy-box markup itself is never edited. */
    var firstForm = document.querySelector("[data-buybox]");
    var mover = document.querySelector("[data-moka-offer-panel][data-moka-offer-move]");
    if (mover && firstForm && firstForm.parentNode) firstForm.parentNode.insertBefore(mover, firstForm);
    Array.prototype.forEach.call(panels, function (p) {
      p.hidden = false;
      p.querySelectorAll("[data-offer-claimed]").forEach(function (el) { rollNumber(el, shown); });
      p.querySelectorAll("[data-offer-cap]").forEach(function (el) { el.textContent = OFFER.cap; });
      p.querySelectorAll("[data-offer-left]").forEach(function (el) { rollNumber(el, OFFER.cap - shown); });
      p.querySelectorAll("[data-offer-bar]").forEach(function (el) { el.style.width = (shown / OFFER.cap * 100) + "%"; });
    });
    tick();
    timer = setInterval(tick, 1000);
    syncHeaderOffset();
    window.addEventListener("resize", syncHeaderOffset);
  })();
})();
